






































































































































































import Vue from 'vue';
import BreadCrumbs from '@/components/bread-crumbs/BreadCrumbs.vue';
import FilterIcon from '@/assets/icons/FilterIcon.vue';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import { getCoBuyers, hideLoader, isMobile, showLoader } from '@/util';
import { mapGetters } from 'vuex';
import { Member, User, MessageData, MessageThread, AttachmentUrls, MessageEntity, Milestones, CustomerCare, HomeSummary } from '@/types';
import { deleteAttachment, getAllConversationThreads, getConversationMessages, getHomeDetails, getTeamMembers, messageCountSync, sendMessage } from '@/api';
import { convertThreadMemberToBuyer, convertThreadMemberToTeamMember, setNewMessageFlag, isNewMessage, generateUniqueId, generateMessageRequest, generateThreadMembers } from './services/service';
import { calculateDateTimeDifference } from '@/util/date-helper';
import { bus } from '@/main';
import { ActionType, BuyerType, EventType, JobStatus } from '@/constants';
import InfoIcon from '@/assets/icons/InfoIcon.vue';
import { jobOwnershipStatus } from '../dashboard/services/service';

export default Vue.extend({
  name: 'Messages',
  components: {
    Message: () => import('./components/Message.vue'),
    ConversationsList: () => import('./components/ConversationsList.vue'),
    ComposePanel: () => import('./components/ComposePanel.vue'),
    RecipientPanel: () => import('./components/RecipientPanel.vue'),
    AttachmentsModal: () => import('./components/AttachmentsModal.vue'),
    FilterIcon,
    CloseIcon,
    BreadCrumbs,
    InfoIcon
  },
  data () {
    return {
      supervisorId: this.$route.params.teamMemberId || '',
      isOpenRecipientsPanel: false,
      teamMembers: [] as Member[],
      customerCareData: {} as CustomerCare,
      selectedRecipients: {
        teamMembers: [] as Member[],
        coBuyers: [] as User[]
      },
      recipientSelectionError: '',
      conversations: [] as MessageThread[],
      activeConversation: '',
      newMessage: false,
      messages: [] as MessageData[],
      totalThreads: -1,
      isVisibleAttachmentsModal: false,
      filterDropdown: false,
      selectedFilter: '',
      searchText: '',
      placeholder: 'Search messages',
      clearSearch: false,
      debounce: null as any,
      uploadedFiles: [] as AttachmentUrls[],
      newThreadId: '',
      loading: false,
      isCollapsedFolder: true,
      conversationsPage: 1,
      messagesPage: 1,
      hasMoreConversations: true,
      hasMoreMessages: true,
      conversationsLoading: false,
      messagesLoading: false,
      isScrollingUp: false
    }
  },
  computed: {
    ...mapGetters(['selectedJob', 'user', 'isCoBuyer', 'isLoggedInAsAdmin', 'mileStones', 'jobDetails']),
    coBuyers (): User[] {
      return getCoBuyers(this.selectedJob);
    },
    activeThread (): MessageThread {
      return this.activeConversation ? this.conversations.find(conversation => conversation.messageThreadId === this.activeConversation) || {} as MessageThread : {} as MessageThread;
    },
    getParams (): any {
      return {
        filterBy: {
          startDate: this.selectedFilter === 'new' ? calculateDateTimeDifference(new Date(), +process.env.VUE_APP_NEW_MESSAGE_CONFIG).toISOString() : '',
          endDate: this.selectedFilter === 'new' ? new Date().toISOString() : '',
          weekNumber: 0,
          recipient: []
        },
        buyer: {
          email: this.user.email,
          jobId: this.selectedJob
        },
        searchText: this.searchText,
        sort: {
          sortBy: '',
          isAscending: true
        },
        pageNo: this.conversationsPage,
        pageSize: 10
      }
    },
    filteredConversations (): MessageThread[] {
      return this.conversations;
    },
    noSearchResultsFound (): boolean {
      return !!(this.searchText && !this.conversations.length && this.totalThreads > 0);
    },
    noFilteredResultsFound (): boolean {
      return !!(this.selectedFilter && !this.filteredConversations.length && this.totalThreads > 0);
    },
    attachments (): string[] {
      return this.uploadedFiles.length ? this.uploadedFiles.map(file => file.url) : [] as string[];
    },
    isMobileDevice (): boolean {
      return isMobile();
    },
    isActiveThreadPostClose (): boolean {
      return this.postClose ? this.newMessage || new Date(this.activeThread.createdDate) > new Date(this.postCloseDate) : true;
    },
    isThreadOpen (): boolean {
      if (this.activeConversation) {
        const threadTeamMembers = this.activeThread?.members?.filter(members => members.type === 'ADMIN');
        return threadTeamMembers.every(member => this.teamMembers.findIndex(teamMember => teamMember.email === member.email) > -1) && this.isActiveThreadPostClose;
      }
      return true;
    },
    postClose (): boolean {
      return [JobStatus.POST_CLOSE].includes(jobOwnershipStatus());
    },
    postCloseDate (): string {
      const postCloseDates = [] as string [];
      this.mileStones.Own.steps.forEach((step: Milestones) => {
        for (const [key, value] of Object.entries(step)) {
          if (key.endsWith('Date') && value) {
            postCloseDates.push(value);
          }
        }
      });
      if (postCloseDates && postCloseDates.length) {
        const closeDates: Date[] = postCloseDates.map(dateStr => new Date(dateStr));
        const lowestDate = closeDates.reduce((minDate, currDate) => {
          if (!minDate || currDate < minDate) {
            return currDate;
          }
          return minDate;
        })
        return lowestDate.toISOString();
      } else {
        return '';
      }
    },
    isErrorMode (): boolean {
      return !!(this.noSearchResultsFound || this.noFilteredResultsFound);
    },
    isMessageComposeMode (): boolean {
      return !!(this.activeConversation || this.newMessage);
    },
    isVisibleRightPanel (): boolean {
      return this.isMessageComposeMode || (!this.isMessageComposeMode && !this.filteredConversations.length) || this.isErrorMode;
    },
    latestMessageInActiveThread (): MessageData {
      return this.messages.length > 0 ? this.messages[this.messages.length - 1] : {} as MessageData;
    }
  },
  created () {
    window.addEventListener('click', this.hideDropDown);
  },
  async mounted () {
    this.loading = true;
    await Promise.all([this.fetchActiveTeamMembers(), this.fetchAllConversations(), this.fetchHomeDetails()]);
    this.totalThreads = this.conversations.length;
    if (this.totalThreads === 0 || this.isMobileDevice) {
      this.loading = false;
    }
    if (this.supervisorId) {
      this.messages = [];
      this.createNewConversation(false);
      // this.$router.replace({
      //   params: {
      //     teamMemberId: ''
      //   }
      // });
      this.$router.push({ path: '/messages', replace: true })
      this.supervisorId = '';
    }
  },
  beforeDestroy () {
    window.removeEventListener('click', this.hideDropDown);
  },
  watch: {
    async activeConversation (value) {
      this.isOpenRecipientsPanel = false;
      this.newMessage = false;
      if (this.uploadedFiles.length) {
        await this.deleteAllFiles(this.uploadedFiles);
        this.$emit('resetAttachmentsData');
      }
      this.resetRequestData();
      this.messages = [];
      this.newThreadId = '';
      if (value) {
        this.loading = true;
        await this.fetchMessages();
        this.isMobileDevice && this.focusToComposePanel();
        this.loading = false;
      }
    },
    messages: {
      handler (value) {
        if (value) {
          setTimeout(() => {
            this.updateScrollPosition();
          }, 100);
        }
      },
      deep: true
    },
    filteredConversations: {
      handler () {
        const idx = this.filteredConversations.findIndex(el => el.messageThreadId === this.activeConversation);
        if ((this.activeConversation && idx === -1)) {
          this.resetConversationData();
          if (!this.isMobileDevice && !this.newMessage) {
            this.setActiveConversation(this.filteredConversations[0]?.messageThreadId || '');
          }
        } else if (!this.isMessageComposeMode) {
          this.setDefaultActiveChat();
        }
      },
      deep: true
    },
    async searchText (newValue, oldValue) {
      this.newMessage = false;
      this.clearSearch = oldValue.length > 2 && !newValue;
      if (newValue.length >= 3) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.executeSearchOperation();
        }, 600);
      } else if (oldValue && !newValue) {
        clearTimeout(this.debounce);
        this.executeSearchOperation();
      }
    },
    loading (value) {
      if (value) {
        showLoader();
      } else {
        hideLoader();
      }
    }
  },
  methods: {
    async fetchActiveTeamMembers () {
      const response = await getTeamMembers(this.selectedJob);
      const data = response.members as Member[];
      const activeTeamMembers = data.filter((member) => member.status.toLowerCase() === 'active');
      this.teamMembers = activeTeamMembers;
    },
    async fetchAllConversations (isLoadMore = false) {
      if (isLoadMore) {
        this.conversationsLoading = true;
      } else {
        this.conversationsPage = 1;
        this.hasMoreConversations = true;
      }
      const response = await getAllConversationThreads(this.getParams);
      const newConversations = setNewMessageFlag(response.data as MessageThread[]);
      if (isLoadMore) {
        this.conversations = [...this.conversations, ...newConversations];
      } else {
        this.conversations = newConversations;
      }
      this.hasMoreConversations = newConversations.length === 10;
      this.conversationsLoading = false;
      this.setDefaultActiveChat();
    },
    async fetchMessages (isLoadMore = false) {
      if (this.supervisorId) {
        this.messages = [];
      } else {
        if (isLoadMore) {
          this.messagesLoading = true;
        } else {
          this.messagesPage = 1;
          this.hasMoreMessages = true;
        }
        const response = await getConversationMessages(this.activeConversation, {
          ...(this.searchText ? { searchText: this.searchText } : {}),
          pageNumber: this.messagesPage,
          pageSize: 10
        });
        const newMessages = response.messages;
        if (isLoadMore) {
          const scrollEl = this.$refs.messageList as HTMLElement;
          const previousHeight = scrollEl.scrollHeight;
          this.messages = [...newMessages, ...this.messages];
          this.$nextTick(() => {
            scrollEl.scrollTop = scrollEl.scrollHeight - previousHeight;
          });
        } else {
          this.messages = newMessages;
          await this.messageCountUpdate();
        }
        this.hasMoreMessages = newMessages.length === 10;
        this.messagesLoading = false;
      }
    },
    async fetchHomeDetails () {
      if (!this.jobDetails) {
        getHomeDetails(this.selectedJob).then((response: HomeSummary) => {
          if (response) {
            this.$store.dispatch(ActionType.SET_JOB_DETAILS, response);
            this.customerCareData = response.customerCare;
          }
        })
      } else {
        this.customerCareData = this.jobDetails.customerCare;
      }
    },
    setMessageRecipients (data: any) {
      this.recipientSelectionError = '';
      this.isOpenRecipientsPanel = false;
      const { coBuyers, teamMembers } = data;
      this.selectedRecipients.coBuyers = coBuyers;
      this.selectedRecipients.teamMembers = teamMembers;
      this.focusToComposePanel();
    },
    validateRecipients () {
      this.recipientSelectionError = '';
      if (!this.selectedRecipients.teamMembers.length && !this.selectedRecipients.coBuyers.length) {
        this.recipientSelectionError = 'Please select a recipient.'
      } else if (!this.selectedRecipients.teamMembers.length) {
        this.recipientSelectionError = 'Add a Drees Team Member as recipient.';
      }
    },
    createNewConversation (clearFilter = true) {
      if (!this.isLoggedInAsAdmin) {
        if (clearFilter) {
          this.selectedFilter = '';
        }
        this.searchText = '';
        this.resetConversationData();
        this.loading = true;
        const timer = setTimeout(() => {
          this.newMessage = true;
          clearTimeout(timer);
          this.loading = false;
        }, 100);
        if (this.supervisorId) {
          const supervisorData = this.teamMembers.find((member) => member.userId === +this.supervisorId);
          if (supervisorData) {
            this.selectedRecipients.teamMembers.push(supervisorData);
          }
        }
      } else {
        bus.$emit(EventType.VIEW_VERSION);
      }
    },
    async addNewMessage (messageData: MessageEntity, idx = -1) {
      this.loading = true;
      this.newThreadId = this.activeConversation || this.newThreadId || generateUniqueId().toString();
      const recipients = generateThreadMembers(this.user, this.selectedRecipients.coBuyers, this.selectedRecipients.teamMembers);
      const { requestData, conversation, message } = generateMessageRequest(this.selectedJob, this.newThreadId, this.activeThread?.groupName || '', messageData, recipients, this.customerCareData?.custCareServiceEmail);
      try {
        const response = await sendMessage(requestData);
        conversation.lastMessageData.messageSubject = response.data.messageSubject;
        message.messageSubject = response.data.messageSubject;
        conversation.isNewMsg = isNewMessage(conversation.lastMessageData.createdDate);
        this.addToChat(conversation, message, idx, false, response.data.messageId, response.data.messageThreadId);
        this.loading = false;
      } catch (error) {
        this.addToChat(conversation, message, idx);
        this.loading = false;
      }
    },
    async handleSendMessage (data: any) {
      this.validateRecipients();
      if (!this.recipientSelectionError) {
        if (!this.isLoggedInAsAdmin) {
          const messageData = {
            messageData: data.message,
            messageSubject: data.messageSubject,
            attachments: this.attachments
          } as MessageEntity;
          await this.addNewMessage(messageData);
          (this.$refs.composePanelRef as any).resetData();
          this.resetRequestData();
        } else {
          bus.$emit(EventType.VIEW_VERSION);
        }
      }
    },
    toggleRecipientsPanel () {
      this.isOpenRecipientsPanel = !this.isOpenRecipientsPanel;
    },
    setActiveConversation (threadId: string) {
      this.selectedRecipients = {
        teamMembers: [],
        coBuyers: []
      };
      if (this.activeConversation === threadId) {
        this.activeConversation = '';
      } else {
        this.activeConversation = threadId;
        const buyers = this.activeThread.members.filter(member => member.type.toLowerCase() === BuyerType.BUYER.toLowerCase());
        const teamMembers = this.activeThread.members.filter(member => member.type.toLowerCase() === 'Admin'.toLowerCase());
        teamMembers.forEach(member => {
          const data = convertThreadMemberToTeamMember(member);
          this.selectedRecipients.teamMembers.push(data);
        });
        buyers.forEach(member => {
          const data = convertThreadMemberToBuyer(member);
          this.selectedRecipients.coBuyers.push(data);
        })
        this.selectedRecipients.coBuyers = this.selectedRecipients.coBuyers.filter(buyer => buyer.email !== this.user.email);
      }
    },
    addMessageToExistingThread (conversation: MessageThread, message: MessageData, retryIdx = -1, sendFailed = true, messageId = '') {
      const idx = this.conversations.findIndex(el => el.messageThreadId === this.activeConversation);
      const data = {
        ...this.conversations[idx],
        lastMessageData: {
          ...conversation.lastMessageData,
          messageId
        },
        isNewMsg: true
      };
      this.conversations.splice(idx, 1);
      this.conversations.unshift(data);
      this.setNewMessageRecord(message, retryIdx, sendFailed, messageId);
    },
    addMessageToNewThread (conversation: MessageThread, message: MessageData, retryIdx = -1, sendFailed = true, messageId = '', messageThreadId = '') {
      this.conversations.unshift(conversation);
      this.activeConversation = messageThreadId;
      this.setNewMessageRecord(message, retryIdx, sendFailed, messageId);
    },
    setNewMessageRecord (message: MessageData, retryIdx: number, sendFailed: boolean, messageId: string) {
      if (retryIdx > -1) {
        this.messages[retryIdx].messageId = messageId;
        this.messages[retryIdx].sendFailed = sendFailed;
      } else {
        this.messages.push({
          ...message,
          sendFailed
        });
      }
    },
    addToChat (conversation: MessageThread, message: MessageData, retryIdx = -1, sendFailed = true, messageId = '', messageThreadId = '') {
      if (sendFailed) {
        this.setNewMessageRecord(message, retryIdx, sendFailed, messageId);
      } else {
        this.activeConversation ? this.addMessageToExistingThread(conversation, message, retryIdx, sendFailed, messageId) : this.addMessageToNewThread(conversation, message, retryIdx, sendFailed, messageId, messageThreadId);
      }
    },
    async retrySend (message: MessageData, idx: number) {
      this.loading = true;
      const messageData = {
        messageData: message.messageData,
        messageSubject: message.messageSubject,
        attachments: message.attachments
      } as MessageEntity;
      await this.addNewMessage(messageData, idx);
      this.loading = false;
    },
    resetRequestData () {
      this.recipientSelectionError = '';
      this.$emit('resetMessageData');
      this.$emit('resetAttachmentsData');
      this.uploadedFiles = [];
    },
    resetConversationData () {
      this.newMessage = false;
      this.activeConversation = '';
      this.newThreadId = '';
      this.messages = [];
      this.selectedRecipients = {
        teamMembers: [],
        coBuyers: []
      };
    },
    async setSelectedFilter (filterType = 'all' || 'new') {
      this.newMessage = false;
      this.selectedFilter = filterType;
      this.filterDropdown = false;
      await this.fetchAllConversations();
    },
    clearSearchAndFilter () {
      this.selectedFilter = '';
      this.searchText = '';
    },
    hideDropDown (e: Event) {
      const dropdown = document.querySelector('.dropdown-show');
      if (dropdown && !dropdown.contains(e.target as Node)) {
        this.filterDropdown = false;
      }
    },
    async executeSearchOperation () {
      const el = this.$refs.input as HTMLElement;
      this.loading = true;
      el.blur();
      await this.fetchAllConversations();
      if (this.activeConversation) {
        await this.fetchMessages();
      }
      if (!this.clearSearch && !this.isMobileDevice) {
        el.focus();
      }
      this.loading = false;
    },
    openAttachmentsModal () {
      if (!this.isLoggedInAsAdmin) {
        this.isVisibleAttachmentsModal = !this.isVisibleAttachmentsModal;
        if (this.isVisibleAttachmentsModal) {
          this.newThreadId = this.activeConversation || this.newThreadId || generateUniqueId().toString();
        }
      } else {
        bus.$emit(EventType.VIEW_VERSION);
      }
    },
    attachmentUploaded (uploadedFiles: AttachmentUrls[]) {
      this.uploadedFiles = [];
      this.uploadedFiles = uploadedFiles;
      this.isVisibleAttachmentsModal = false;
    },
    removeRecipient (data: any) {
      if (data.type === 'admin') {
        const idx = this.selectedRecipients.teamMembers.findIndex(member => member.userId === data.id);
        this.selectedRecipients.teamMembers.splice(idx, 1);
      } else {
        const idx = this.selectedRecipients.coBuyers.findIndex(coBuyer => coBuyer.email === data.id);
        this.selectedRecipients.coBuyers.splice(idx, 1);
      }
      this.focusToComposePanel();
    },
    focusToComposePanel () {
      const el = document.querySelector('.compose-panel') as HTMLElement;
      if (el) {
        el.focus();
      }
    },
    updateScrollPosition (value?: number) {
      const el = this.$refs.messageList as HTMLElement;
      const lastMessage = (this.$refs.lastMessage as HTMLElement[]);
      const recipientHeader = (this.$refs.recipientPanelRef as Vue)?.$el
      if (el && !value && lastMessage && recipientHeader) {
        el.scrollTop = lastMessage[0]?.offsetTop - recipientHeader?.clientHeight;
      } else if (el && value) {
        el.scrollTop = el.scrollHeight - value;
      }
    },
    async deleteAttachment (data: { fileName: string; id: string }, isMultipleDelete = false) {
      this.loading = true;
      const fileIdx = this.uploadedFiles.findIndex(file => file.id === data.id);
      await deleteAttachment({
        fileName: data.fileName,
        messageThreadId: this.newThreadId
      });
      if (!this.isVisibleAttachmentsModal) {
        this.uploadedFiles.splice(fileIdx, 1);
        const { removeAttachmentFromList } = this.$refs.attachmentModal as any;
        removeAttachmentFromList(data.id);
      }
      if (!isMultipleDelete) {
        this.loading = false;
      }
    },
    async deleteAllFiles (files: any) {
      this.isVisibleAttachmentsModal = false;
      this.loading = true;
      await Promise.all(
        files.map(async (file: any) => {
          await this.deleteAttachment(file, true);
        }));
      this.uploadedFiles = [];
      this.$emit('resetAttachmentsData');
      this.loading = false;
    },
    setDefaultActiveChat () {
      if (!this.isMobileDevice && !this.activeConversation && !this.newMessage) {
        this.setActiveConversation(this.filteredConversations[0]?.messageThreadId || '');
      }
    },
    updateFolderState () {
      this.isCollapsedFolder = !this.isCollapsedFolder;
      // const el = document.querySelector('#folder-contents');
      // if (el && this.isCollapsedFolder) {
      //   el.scrollIntoView();
      // }
    },
    handleMobileBack () {
      this.resetConversationData();
      this.resetRequestData();
    },
    async messageCountUpdate () {
      await messageCountSync({
        threadId: this.activeConversation,
        user: this.user.contactId,
        type: BuyerType.BUYER.toUpperCase()
      });
    },
    handleConversationsScroll (e: any) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.hasMoreConversations && !this.conversationsLoading) {
        this.conversationsPage++;
        this.fetchAllConversations(true);
      }
      this.isScrollingUp = scrollTop > 1;
    },
    handleMessagesScroll (e: any) {
      const { scrollTop } = e.target;
      if (scrollTop <= 5 && this.hasMoreMessages && !this.messagesLoading) {
        this.messagesPage++;
        this.fetchMessages(true);
      }
    },
    scrollToTop () {
      const el = this.$refs.conversationsListContainer as HTMLElement;
      if (el) {
        el.scrollTop = 0;
      }
    }
  }
});
